var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticStyle:{"margin-top":"25px"},attrs:{"variant":"primary","block":""},on:{"click":_vm.handleDownloadPDF}},[_vm._v("\n      Download PDF\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }